import React from "react";
import { IconButton, Menu, Popover } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import COLORS from "scss/colors.module.scss";
import {
  IoMdSettings,
  IoMdCloudDownload,
  IoMdCloudUpload,
} from "react-icons/io";
import { MdEdit } from "react-icons/md";
import { FaDatabase, FaCogs, FaTh } from "react-icons/fa";
import { BiNetworkChart } from "react-icons/bi";
import { AiOutlineBgColors } from "react-icons/ai";
import { GrMail } from "react-icons/gr";
import { CgNotes } from "react-icons/cg";
import { inject, observer } from "mobx-react";
import Triggers from "./Triggers";
import RolesAndPermissions from "./RolesAndPermissions";
import MenuItem from "@material-ui/core/MenuItem";
import { ContainerStoreContext, ViewStoreContext } from "../ContainerStore";
import styled from "styled-components";
import ViewAggregationPopup from "app/ViewAggregation/ViewAggregationPopup";

function Settings() {
  const containerStore = React.useContext(ContainerStoreContext);
  const viewStore = React.useContext(ViewStoreContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const listConfig = containerStore.listConfig;
  const list = listConfig.list;
  const listId = list.id;
  // const [popState, setpopState] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handlePopoverOpen = (event) => {
  //   setpopState(event.currentTarget);
  // };

  // const handlePopoverClose = () => {
  //   setpopState(null);
  // };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // const openPop = Boolean(popState);
  // const popId = openPop ? "nested-popover" : undefined;
  
  return (
    <>
      <IconButton aria-describedby={id} onClick={handleClick}>
        <IoMdSettings size={18} color={COLORS.TEXT_COLOR} />
      </IconButton>
      <Menu
        // id="user-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        disableAutoFocusItem={true}
      >
        {containerStore?.view?.type === "table" && containerStore.listConfig?.list?.is_log_sheet != 1 && (
          <MenuItem
            onClick={() => {
              handleClose();
              showImportWindow(listId, listConfig.listData, async () => {
                await viewStore?.refreshData(true);
              }, false);
            }}
          >
            <IconWrapper>
              <IoMdCloudUpload size={18} color={COLORS.TEXT_COLOR} />
            </IconWrapper>
            Import
          </MenuItem>
        )}

        {containerStore?.view?.type == "table" && window.LOGGED_IN_USER.domain == "viaterra" && listId == "75006826" && (
          <MenuItem
            onClick={() => {
              handleClose();
              showImportWindow(listId, listConfig.listData, async () => {
                await viewStore?.refreshData(true);
              }, true);
            }}
          >
            <IconWrapper>
              <IoMdCloudUpload size={18} color={COLORS.TEXT_COLOR} />
            </IconWrapper>
            Import Dealer Excel
          </MenuItem>
        )}

        {/* <MenuItem onClick={handlePopoverOpen}>
          <IoMdCloudDownload
            style={{ marginLeft: -8, marginRight: 3 }}
            size={18}
            color={COLORS.TEXT_COLOR}
          />
          Export
        </MenuItem>
        <Popover
          id={popId}
          open={openPop}
          anchorEl={popState}
          onClose={handlePopoverClose}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <div>
            <MenuItem>Export as CSV</MenuItem>
          </div>
          <div>
            <MenuItem>Export as XLSX</MenuItem>
          </div>
        </Popover> */}
        {containerStore?.permissions?.canShare() && (
          <div>
            {/* <MenuItem>
              <div>
                <MdEdit
                  style={{ marginLeft: -8, marginRight: 3 }}
                  size={18}
                  color={COLORS.TEXT_COLOR}
                />
                Modify Sheet Columns
              </div>
            </MenuItem> */}

            <MenuItem
              onClick={() => {
                handleClose();
                showWorkFlows(listId, listConfig?.list?.name, listConfig?.listData, containerStore);
              }}
            >
              <IconWrapper>
                <BiNetworkChart
                  size={18}
                  color={COLORS.TEXT_COLOR}
                />
              </IconWrapper>
              Workflows
            </MenuItem>
            <Triggers handleClose={handleClose} />
            <RolesAndPermissions handleClose={handleClose} />
            <MenuItem
              onClick={() => {
                handleClose();
                containerStore.appStore.emailIntegrationsStore.showSelectEmailDialog();
              }}
            >
              <IconWrapper>
                <GrMail
                  size={18}
                  color={COLORS.TEXT_COLOR}
                />
              </IconWrapper>
              Fetch from Email
            </MenuItem>
          </div>
        )}
        {/* <MenuItem>
          <IconWrapper>
            <FaTh
              size={18}
              color={COLORS.TEXT_COLOR}
            />
          </IconWrapper>
          Analaytics
        </MenuItem> */}
        <ViewAggregationPopup handleClose={handleClose} store={containerStore?.viewAggregationStore} />
        {containerStore?.permissions?.canShare() && (
          <div>
            <Separator></Separator>
            <MenuItem
              onClick={() => {
                handleClose();
                showVariables(listId);
              }}
            >
              <IconWrapper>
                <FaDatabase
                  size={18}
                  color={COLORS.TEXT_COLOR}
                />
              </IconWrapper>
              Sheet Variables
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                showWebforms(list, listConfig.listData);
              }}
            >
              <IconWrapper>
                <CgNotes size={18} color={COLORS.TEXT_COLOR} />
              </IconWrapper>
              Web Forms
            </MenuItem>
            {/* <MenuItem>
              <FaCogs
                style={{ marginLeft: -8, marginRight: 3 }}
                size={18}
                color={COLORS.TEXT_COLOR}
              />
              Fields
          </MenuItem> */}
          </div>
        )}
      </Menu>
    </>
  );
}

function showWebforms(list, listColumns, onSuccess = () => {}) {
  const webFormsWin = Ext.create("TL.Window", {
    title: "Web Forms",
    modal: true,
    width: 1000,
    autoScroll: true,
    cls: "tl-window webforms-win",
    helpLinkIdentifier: "web-forms",
    items: [
      Ext.create("TL.web-forms.List", {
        autoHeight: true,
        anchor: "100%",
        border: false,
        list: list,
        listColumns: listColumns,
        listeners: {
          close: function () {
            webFormsWin.close();
          },
          success: onSuccess,
          scope: this,
        },
      }),
    ],
  });
  webFormsWin.show();
}

function showImportWindow(listId, listColumns, onSuccess, isViaterraSheet = false) {
  var formWin = Ext.create("TL.list.imports.ImportWindow", {
    title: "Import to your sheet",
    //maxHeight: 500,
    modal: true,
    width: 1000,
    autoScroll: true,
    config: {
      list: { id: listId },
      list_columns: listColumns,
    },
    isViaterraSheet: isViaterraSheet,
    cls: "tl-window import-panel-win",
    listeners: {
      success: onSuccess,
      scope: this,
    },
  });
  formWin.show();
}

function showWorkFlows(listId, listName, listColumns, containerStore) {
  let workflowConfigPanel;
  const workflowWin = Ext.create("TL.Window", {
    title: "Workflows",
    modal: true,
    width: 800,
    autoScroll: true,
    cls: 'tl-window workflow-config-win',
    helpLinkIdentifier: "workflows",
    items: [workflowConfigPanel = Ext.create("TL.workflows.ConfigPanel", {
        autoHeight: true,
        anchor: "100%",
        border: false,
        currentList: {
          id: listId,
          name: listName,
          columns: listColumns,
        },
        listeners: {
            close: function () {
                workflowWin.close();
            },
            success: async function () {
                //viewPort.loadGridComponent(listId);
                await containerStore.loadGrid();
            },
            scope: this
        }
    })]
  });

  workflowWin.on('beforeclose', function () {
      return workflowConfigPanel.showCloseAlert();
  }, this);

  workflowWin.show();
}

function showVariables(listId) {
  const importForm = Ext.create("TL.variables.List", {
    bodyStyle: "padding:10px",
    autoHeight: true,
    border: false,
    list: {
      id: listId,
    },
    listeners: {
      success: Ext.bind(function () {
        variablesWindow.close();
      }, this),
      close: Ext.bind(function () {
        variablesWindow.close();
      }, this),
      scope: this,
    },
  });

  let variablesWindow = Ext.create("TL.Window", {
    width: 800,
    minHeight: 400,
    title: "Variables",
    border: false,
    helpLinkIdentifier: "variables",
    items: [
      {
        xtype: "panel",
        border: false,
        items: [importForm],
      },
    ],
  });
  variablesWindow.show();
}

const IconWrapper = styled.div`
  margin-right: 15px;
`;

const Separator = styled.div`
  border-bottom: 1px solid #e0dcdc;
  margin: 6px 16px;
`;
export default observer(Settings);
